import { gql } from '@apollo/client';

export default gql`
  query Me {
    me {
      id
      wishlist {
        id
        externalId
        name
        shortDescription
        thumbnail
      }
      enableDashboard
      preferences @client {
        id
        version
        audioMuted
        soundtrackMuted
        textTrackLanguage
        lastViewedContent
        hotspotTutorialOptOut
        equirectangularPictureGyroscopeTutorialOptOut
      }
    }
  }
`;
